import { useState } from "react";

function initialsFromName(name) {
	const trimmed = (name ?? "").trim();
	if (!trimmed) return "";
	const parts = trimmed.split(/\s+/).filter(Boolean);
	if (parts.length >= 2) {
		return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`;
	}
	return trimmed.charAt(0);
}

function UserIcon({ className }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden
		>
			<circle cx="12" cy="8" r="3.5" opacity="0.85" />
			<path d="M5 20c0-3.5 3.1-6 7-6s7 2.5 7 6" opacity="0.75" />
		</svg>
	);
}

const SIZE_PRESETS = {
	sm: {
		box: "h-8 w-8",
		text: "text-[11px]",
		icon: "h-[14px] w-[14px]",
	},
	md: {
		box: "h-10 w-10",
		text: "text-[13px]",
		icon: "h-[18px] w-[18px]",
	},
	lg: {
		box: "w-full aspect-square",
		text: "text-[28px]",
		icon: "h-10 w-10",
	},
};

export default function ProfileAvatar({
	imageUrl,
	name,
	size = "md",
	variant = "light",
	className = "",
}) {
	const [imgError, setImgError] = useState(false);
	const showImage = imageUrl && !imgError;
	const preset = SIZE_PRESETS[size] ?? SIZE_PRESETS.md;
	const initials = initialsFromName(name);

	const emptySurface =
		variant === "onDark"
			? "bg-gradient-to-br from-white/20 to-white/5 ring-1 ring-inset ring-white/30 text-white/90"
			: "bg-gradient-to-br from-[#E8F3FC] via-[#F4F9FD] to-[#C5DCF2] ring-1 ring-inset ring-darkBlue/12 text-darkBlue/60";

	const boxClass = [preset.box, "shrink-0 overflow-hidden rounded-full", className]
		.filter(Boolean)
		.join(" ");

	if (showImage) {
		return (
			<div className={boxClass}>
				<img
					src={imageUrl}
					alt=""
					className="h-full w-full object-cover"
					loading="lazy"
					onError={() => setImgError(true)}
				/>
			</div>
		);
	}

	return (
		<div
			className={[
				"flex items-center justify-center",
				boxClass,
				emptySurface,
			].join(" ")}
			aria-hidden={!name}
		>
			{initials ? (
				<span className={`font-Vazir-700 leading-none ${preset.text}`}>
					{initials}
				</span>
			) : (
				<UserIcon className={`${preset.icon} opacity-75`} />
			)}
		</div>
	);
}
